export default __webpack_public_path__ + "../img/wooCommece_inventory.png";